import {
    _axios as request
} from "../../plugins/axios";

const actions = {
    getPositiveFeedbackRate(){
        return new Promise((resolve, reject) => {
            request({
                url: '/statistics/positiveFeedbackRate',
                method: 'get',
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    getTotalOrder(){
        return new Promise((resolve, reject) => {
            request({
                url: '/statistics/totalOrder',
                method: 'get',
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    getOnTimeRate(){
        return new Promise((resolve, reject) => {
            request({
                url: '/statistics/onTimeRate',
                method: 'get',
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    getDaily(){
        return new Promise((resolve, reject) => {
            request({
                url: '/user/healthInformation/getDaily',
                method: 'get',
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
//    问题反馈
    getFeedbackList(_,data){
        return new Promise((resolve, reject) => {
            request({
                url: '/statistics/feedbackList',
                method: 'post',
                params: data,
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
//    订单明细表
    getOrderListTable(_,data){
        return new Promise((resolve, reject) => {
            request({
                url: '/statistics/orderListTable',
                method: 'post',
                params: data,
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
//    商品销量数据统计表
    getSpuSalesTable(_, data){
        return new Promise((resolve, reject) => {
            request({
                url: '/statistics/spuSalesRankTable',
                method: 'post',
                params: data
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
//    病区
    getBedInformation(){
        return new Promise((resolve, reject) => {
            request({
                url: '/user/bedInformation',
                method: 'post',
                params: {campus: '江苏省中医院紫东分院'},
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
//    根据时间和病区，商品销售详情统计表
    getSalesTable(_,data){
        return new Promise((resolve, reject) => {
            request({
                url: '/statistics/salesTable',
                method: 'post',
                params: data,
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
//    某月份订单数量折线图
    getOrderQuantityMonthly(_,data){
        return new Promise((resolve, reject) => {
            request({
                url: '/statistics/orderAmountInMonthChart',
                method: 'post',
                params: data,
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
//    各病区订单排名
    getOrderAmountAndSalesChart(_,data){
        return new Promise((resolve, reject) => {
            request({
                url: '/statistics/orderAmountPortionAndSalesPortionChart',
                method: 'post',
                params: data,
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
//    商品销售数量占比
    getProductSaleAmountChart(_,data){
        return new Promise((resolve, reject) => {
            request({
                url: '/statistics/spuSalesAmountAndPortionChart',
                method: 'post',
                params: data,
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
//    库存信息统计表
    getStockTable(){
        return new Promise((resolve, reject) => {
            request({
                url: '/statistics/stockTable',
                method: 'post',
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
//    获取导出任务列表
    getall(_, data){
        return new Promise((resolve, reject) => {
            request({
                url: '/statistics/getall',
                method: 'post',
                params: data,
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }
};

export default {
    namespaced: true,
    actions,
}
